module.exports = __webpack_public_path__ + "6785ed80de15fba96897473a8f752cfd.svg";